export default __webpack_public_path__ + "static/Plots0003-7af40692631902625401491072e4b971.jpg";